import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import { Spinner } from '@skunexus/component-catalog';
import { actions as notification } from '@skunexus/notification';
import withProductsTabsWrapper from '../../../../modules/products/components/withProductsTabsWrapper';

import useProduct from '../hooks/useProduct';
import PriceBar from '../components/PriceBar';
import ProductBarcodeHeader from '../components/ProductBarcodeHeader';

const mapStateToProps = () => ({});

const mapDispatchToProps = {
    errorNotification: notification.error,
};

export const withCustomProductBarcodesHoc = (app) => (Component) => {
    function WrappedComponent(props) {
        const { errorNotification } = props;
        const params = useParams();
        const { id } = params;

        const { product, isFetching, fetchProduct } = useProduct({ errorNotification });

        useEffect(() => {
            if (id) {
                fetchProduct(id);
            }
        }, [id]);

        const customPrintBarcodesConfig = () => ({
            labelWidth: 41.275,
            labelHeight: 41.275,
            commonBarcodeConfig: {
                showLabel: false,
                imageConfig: {
                    height: 80,
                    show_text: 0,
                },
                barcodeHeader: <ProductBarcodeHeader logoProps={{}} skuBarProps={{ product }} />,
                barcodeFooter: <PriceBar product={product} />,
            },
            inlineStyles: {
                labelStyle: {
                    fontSize: '14px',
                    margin: '-1px 0 5px',
                },
                printLabelStyle: {
                    padding: '0 2mm',
                },
                imageStyle: {
                    maxWidth: '100%',
                    minWidth: 'auto',
                    width: '100%',
                    height: '80px',
                    margin: '2mm auto',
                },
            },
        });

        if (isFetching) {
            return <Spinner className="mt-3" />;
        }

        return <Component {...props} customPrintBarcodesConfig={customPrintBarcodesConfig} />;
    }

    return withProductsTabsWrapper(app)(connect(mapStateToProps, mapDispatchToProps)(WrappedComponent));
};
